import React from "react";
import { FaHeart } from "react-icons/fa";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";

import "./styles/WishList.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions_wish from "../redux/actions/wishActions";
import * as actions_ad from "../redux/actions/adActions";
import ProductCard, { getKindCommerceLabel } from "./ProductCard";
import MiniLoader from "./MiniLoader";

class WishList extends React.Component {
  onClickRemove = async (ad) => {
    await this.props
      .UpdateWish(this.props.token, {
        goder_id: ad.Id,
        id: this.props.user_id,
      })
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        }
      });
  };

  onClickAd = (item) => {
    this.props.SetAd(item);
  };

  onClickLoadMore = () => {};

  render() {
    const { wishList } = this.props;

    if (!wishList || wishList.length === 0) {
      return (
        <div className="wish-empty">
          <div className="wish-empty__icon" aria-hidden="true">
            <FaHeart />
          </div>
          <p className="wish-empty__text">
            <Translate value="wish_not_list" />
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="product-card-list wish-list">
          {wishList.map((ad) => (
            <ProductCard
              key={ad.Id}
              item={ad}
              kindCommerce={getKindCommerceLabel(ad.KindCommerceId)}
              columnClass="product-card-list__item"
              onClick={() => this.onClickAd(ad)}
              footerAction={
                <button
                  type="button"
                  className="wish-remove-btn"
                  title={I18n.t("wish_remove")}
                  aria-label={I18n.t("wish_remove")}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.onClickRemove(ad);
                  }}
                >
                  <FaHeart />
                  <span>
                    <Translate value="wish_remove" />
                  </span>
                </button>
              }
            />
          ))}
        </div>
        {this.props.page_size >= 10 && (
          this.props.loadingMore ? (
            <div className="product-card-load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="product-card-load-more">
              <button
                type="button"
                className="product-card-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          )
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    error: reducer.wish.error,
    wishList: reducer.wish.list,
    page_size: reducer.wish.page_size,
    page_count: reducer.wish.page_count,
    loadingMore: reducer.wish.loadingMore,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateWish: (token, params) =>
    dispatch(actions_wish.updateItem({ token, params })),
  SetAd: (item) => dispatch(actions_ad.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WishList);
